<div class="p-4 text-center">
  <div class="mb-3">
    <ng-container *ngIf="data?.type == 'warning'; else isSuccess">
      <img width="70px" src="./../../../../assets/images/warning-conform-icon.svg" alt="">
    </ng-container>
    <ng-template #isSuccess>
      <img width="70px" src="./../../../../assets/images/success-check.svg" alt="">
    </ng-template>
  </div>
  <ng-container *ngIf="data?.type == 'warning'; else isSuccessTitle">
    <div class="outline-border-text mb-2">Warning!</div>
  </ng-container>
  <ng-template #isSuccessTitle>
    <div class="outline-border-text mb-2">Success!</div>
  </ng-template>

  <div class="mb-4 d-flex align-items-center justify-content-center">{{data.message}}</div>

  <button [ngClass]="data.type == 'warning' ? 'btn-warning' : 'btn-success'" [mat-dialog-close]="true">
    {{data.confirmCaption}}
  </button>
</div>